import {Component, OnDestroy, OnInit } from '@angular/core';
import {InformationService} from "../../services/information.service";
import {Subject, takeUntil} from "rxjs";
import {environment} from "../../../environments/environment";
import {  SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'customer-agreement',
  templateUrl: './customer-agreement.component.html',
  styleUrls: ['./customer-agreement.component.less']
})
export class CustomerAgreementComponent implements OnInit, OnDestroy{

  addressLink: SafeHtml;
  shopAddress : SafeHtml;
  customerAgreement: SafeHtml;

  private destroySubject: Subject<void> = new Subject();

  constructor(
    private informationService: InformationService,
  ) {
    this.shopAddress = environment.shopAddress.address;
    this.addressLink = environment.shopAddress.link;
  }

  ngOnInit(): void {
   this.informationService.getFrontParams().pipe(
        takeUntil(this.destroySubject),
      )
        .subscribe(
          (res: any) => {
            let customerAgreementHtml = res.results.find ((value:any) =>  value.name == 'customerAgreement')?.value;
            this.customerAgreement = this.informationService.getSanitizeString(customerAgreementHtml);

            let shopAddressHtml  = res.results.find ((value:any) =>  value.name == 'address')?.value;
            this.shopAddress = this.informationService.getSanitizeString(shopAddressHtml);


          })
  }



  ngOnDestroy() {
    this.destroySubject.next();
  }

}




